// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__HhrU1","list":"styles_list__tLRNz"};